/*
 * beneos-survey.js - Fragebogen am persoenlichen Mail-Link.
 *
 * DER TOKEN VERSCHWINDET SOFORT AUS DER ADRESSZEILE
 *
 * Er wird beim Laden aus location.search gelesen, in sessionStorage gelegt
 * und per history.replaceState aus der Adresse entfernt. Das haelt ihn aus
 * document.referrer heraus, aus dem Verlauf und aus jedem Bildschirmfoto.
 * Ein weitergegebener Link waere sonst ein Zugang zum Fragebogen einer
 * anderen Person.
 *
 * Der Sprachwechsel laeuft ueber gewoehnliche Verweise, denen hier der Token
 * angehaengt wird. Der Standard-Sprachumschalter des Themes koennte das
 * nicht: er setzt return_to auf request.path und wirft den Query-String weg.
 *
 * FREITEXT GEHT BASE64 HINAUS
 *
 * Eine WAF prueft eingehende POST-Rumpfe vor PHP und weist bestimmte Muster
 * fuer Unix-Pfade mit einer HTML-403-Seite ab. Die Anfrage taucht dann im
 * PHP-Protokoll gar nicht auf, und im Browser bricht fetch().json() mit
 * "Unexpected token '<'". Ein offenes Textfeld ist genau der Ort, an dem so
 * etwas irgendwann jemand hineinschreibt, ohne es zu meinen. base64 ist fuer
 * die WAF unsichtbar.
 *
 * GESPEICHERT WIRD LAUFEND, NICHT ERST AM ENDE
 *
 * Nach jeder Antwort geht ein kleiner Speicheraufruf raus. Wer auf dem
 * Telefon mitten im Fragebogen unterbrochen wird, verliert damit nichts.
 * Der Absendeknopf schliesst nur ab.
 */
(function () {
  'use strict';

  var wurzel = document.getElementById('beneos-survey');
  if (!wurzel) return;

  var ENDPUNKT = wurzel.getAttribute('data-endpoint');
  var SPRACHE  = wurzel.getAttribute('data-locale') || 'en';
  var SPEICHER = 'beneos_survey_token';

  var elMain   = wurzel.querySelector('[data-bsv-main]');
  var elNoTok  = wurzel.querySelector('[data-bsv-notoken]');
  var elDone   = wurzel.querySelector('[data-bsv-done]');
  var elFragen = wurzel.querySelector('[data-bsv-questions]');
  var elForm   = wurzel.querySelector('[data-bsv-form]');
  var elMsg    = wurzel.querySelector('[data-bsv-msg]');
  var elSubmit = wurzel.querySelector('[data-bsv-submit]');
  var elLead   = wurzel.querySelector('[data-bsv-lead]');
  var elRes    = wurzel.querySelector('[data-bsv-results]');

  var elProg     = wurzel.querySelector('[data-bsv-progress]');
  var elProgTxt  = wurzel.querySelector('[data-bsv-progress-txt]');
  var elProgPct  = wurzel.querySelector('[data-bsv-progress-pct]');
  var elProgBar  = wurzel.querySelector('[data-bsv-progress-bar]');
  var elProgFill = wurzel.querySelector('[data-bsv-progress-fill]');

  var RUHIG = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var T = function (k, d) {
    return (window.Beneos && window.Beneos.t) ? window.Beneos.t('survey.' + k, d) : d;
  };

  /* ── Token ────────────────────────────────────────────────────────── */

  function tokenHolen() {
    var ausAdresse = null;
    try {
      ausAdresse = new URLSearchParams(window.location.search).get('t');
    } catch (e) { /* sehr alter Browser, dann eben nur der Speicher */ }

    if (ausAdresse) {
      try { sessionStorage.setItem(SPEICHER, ausAdresse); } catch (e) {}
      // Sofort aus der Adresszeile nehmen. Das ist der eigentliche Schutz,
      // nicht der Speicher.
      try {
        var sauber = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, sauber);
      } catch (e) {}
      return ausAdresse;
    }

    try { return sessionStorage.getItem(SPEICHER); } catch (e) { return null; }
  }

  var TOKEN = tokenHolen();

  /* ── Zwei Wege auf dieselbe Seite ─────────────────────────────────────

     ?t=  ein Token aus einer Mail. Beweist die Person, geht an
          api-survey.php, funktioniert ohne Anmeldung.

     ?s=  der Schluessel einer Umfrage. Beweist nichts, geht an den App
          Proxy, und dort beweist Shopifys Signatur den angemeldeten
          Besucher. Das ist der verteilbare Link.

     Der Schluessel darf NICHT aus der Adresszeile geraeumt werden. Anders
     als ein Token ist er kein Geheimnis, und ein Sprachwechsel laedt die
     Seite neu: ohne ihn stuende der Besucher danach vor dem Hinweis, er
     moege den Link aus seiner Mail oeffnen.                              */
  var SKEY = null;
  try {
    var roh = new URLSearchParams(window.location.search).get('s');
    if (roh && /^[a-z0-9_]{1,32}$/.test(roh)) SKEY = roh;
  } catch (e) {}

  var MODUS = TOKEN ? 'token' : (SKEY ? 'proxy' : null);

  // Kennung an die Sprachverweise haengen, damit ein Sprachwechsel den
  // Fragebogen nicht leert. Ohne JavaScript fuehrt der Verweis immer noch in
  // die richtige Sprachfassung, dann ohne Kennung und mit dem Hinweis.
  (function sprachlinks() {
    if (!MODUS) return;
    var name = MODUS === 'token' ? 't' : 's';
    var wert = MODUS === 'token' ? TOKEN : SKEY;
    var links = wurzel.querySelectorAll('[data-bsv-lang-link]');
    for (var i = 0; i < links.length; i++) {
      var h = links[i].getAttribute('href');
      if (!h || h.indexOf('?' + name + '=') > -1) continue;
      links[i].setAttribute('href', h + '?' + name + '=' + encodeURIComponent(wert));
    }
  })();

  if (!MODUS) {
    elNoTok.hidden = false;
    return;
  }

  /* ── Hilfen ───────────────────────────────────────────────────────── */

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // UTF-8-feste base64-Kodierung. btoa allein wirft bei allem ausser Latin-1,
  // und der Fragebogen laeuft in dreizehn Sprachen.
  function b64(s) {
    try {
      return btoa(String.fromCharCode.apply(null, new TextEncoder().encode(s)));
    } catch (e) {
      try { return btoa(unescape(encodeURIComponent(s))); } catch (e2) { return s; }
    }
  }

  function melde(text, art) {
    elMsg.textContent = text || '';
    elMsg.className = 'bsv-msg' + (art ? ' is-' + art : '');
  }

  // Der Weg fuer angemeldete Teilnehmer. Der Pfad ist im Theme zwoelffach
  // in Gebrauch, die Signatur legt Shopify selbst bei.
  var PROXY = '/apps/beneos/library?resource=survey';

  function senden(felder) {
    var daten = new URLSearchParams();
    if (MODUS === 'token') daten.set('t', TOKEN);
    else daten.set('s', SKEY);
    daten.set('locale', SPRACHE);
    for (var k in felder) if (Object.prototype.hasOwnProperty.call(felder, k)) daten.set(k, felder[k]);

    var hp = elForm ? elForm.querySelector('input[name="website"]') : null;
    if (hp) daten.set('website', hp.value || '');

    return fetch(MODUS === 'token' ? ENDPUNKT : PROXY, {
      method: 'POST',
      // Auf dem Proxyweg muss das Sitzungsmerkmal mitreisen, sonst kennt
      // Shopify den Angemeldeten nicht und die Signatur kommt ohne
      // Kundenkennung an.
      credentials: MODUS === 'token' ? 'omit' : 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: daten.toString()
    }).then(function (r) {
      // Antwortet die WAF oder der Rand mit HTML, ist r.json() ein
      // Syntaxfehler mit nichtssagender Meldung. Lieber selbst pruefen.
      return r.text().then(function (roh) {
        var j = null;
        try { j = JSON.parse(roh); } catch (e) {}
        return { ok: r.ok, status: r.status, j: j };
      });
    });
  }

  /* ── Aufbau der Fragen ────────────────────────────────────────────── */

  var ZUSTAND = { fragen: [], antworten: {}, textIf: {}, warVoll: false };

  function sichtbar(frage) {
    if (!frage.show_if) return true;
    var teile = String(frage.show_if).split('=');
    if (teile.length !== 2) return true;
    var quelle = teile[0].trim();
    var werte  = teile[1].split('|').map(function (x) { return x.trim(); });
    var a = ZUSTAND.antworten[quelle];
    if (!a || !a.options || !a.options.length) return false;
    for (var i = 0; i < a.options.length; i++) if (werte.indexOf(a.options[i]) > -1) return true;
    return false;
  }

  /* Der Hinweis nennt die Zahl, die wirklich gilt.

     Bis zum 2026-09-02 stand hier max_select === 3, und der Satz erschien nur
     bei genau drei. Bei zwei, vier oder fuenf stand ueber der Frage gar
     nichts, und der Teilnehmer erfuhr die Grenze erst, wenn ihm beim naechsten
     Klick die aelteste Wahl wegsprang. Das trifft join_v1/first_impression
     schon heute, das max_select 2 traegt.

     Beneos.t kann keine Platzhalter, deshalb wird der Wert hier eingesetzt,
     genau wie bei results_n weiter unten.

     EIN EIGENER HINWEIS SCHLAEGT DEN AUTOMATISCHEN SATZ (2026-09-02).
     hint_en gibt es in der Datenbank seit dem Anfang, der Editor hat ein Feld
     dafuer, und der Server schickt es mit. Angezeigt wurde es nie. Der
     Betreiber hat beim ersten echten Bogen in beide Felder getippt und den
     Text nirgends wiedergefunden.

     Nur bei einem selbst angelegten Bogen kann etwas darin stehen: exit_v1
     und join_v1 tragen null Hinweise, in der Datenbank nachgezaehlt, ihre
     Ansicht bleibt deshalb unveraendert. Ein eigener Hinweis ist nicht
     uebersetzt, aber ein Bogen aus dem Admin ist ohnehin nur englisch. */
  function hinweisFuer(frage) {
    var eigen = String(frage.hint_en == null ? '' : frage.hint_en).trim();
    if (eigen !== '') return eigen;
    if (frage.qtype === 'multi' && frage.max_select > 1) {
      return T('pick_up_to_n', 'Pick up to {{ count }}').replace('{{ count }}', frage.max_select);
    }
    if (frage.qtype === 'single' || frage.qtype === 'scale') return T('pick_one', 'Pick one');
    return '';
  }

  /* Beschriftung einer Option oder Skalenstufe.

     Reihenfolge: erst der Locale-Schluessel, dann der Text vom Server, dann
     der nackte Schluessel. Fuer exit_v1 und join_v1 gewinnt der Locale-Weg
     und die dreizehn Sprachen bleiben unberuehrt; ein selbst angelegter
     Bogen hat dort keinen Eintrag, und dann greift labels vom Server. */
  function L(frage, schluessel, wert) {
    var ausDb = (frage.labels && frage.labels[wert]) ? frage.labels[wert] : wert;
    return T(schluessel, ausDb);
  }

  function baueFrage(frage) {
    var q = frage.qkey;
    var a = ZUSTAND.antworten[q] || { options: [], num: null, text: null };

    var h = '<div class="bsv-q" data-q="' + esc(q) + '"' + (sichtbar(frage) ? '' : ' hidden') + '>';
    h += '<h2 class="bsv-q-title">' + esc(T('q_' + q, frage.text_en || q)) + '</h2>';

    var marke = frage.required ? T('required_mark', 'Required') : T('optional_mark', 'Optional');
    var hint  = hinweisFuer(frage);
    h += '<p class="bsv-q-hint">' + esc(marke) + (hint ? ' &middot; ' + esc(hint) : '') + '</p>';

    if (frage.qtype === 'single' || frage.qtype === 'multi') {
      var art = frage.qtype === 'single' ? 'radio' : 'checkbox';
      h += '<div class="bsv-opts">';
      for (var i = 0; i < frage.options.length; i++) {
        var o = frage.options[i];
        var an = a.options.indexOf(o) > -1;
        h += '<label class="bsv-opt' + (an ? ' is-on' : '') + '">'
           + '<input type="' + art + '" name="' + esc(q) + '" value="' + esc(o) + '"' + (an ? ' checked' : '') + '>'
           + '<span>' + esc(L(frage, 'o_' + q + '_' + o, o)) + '</span></label>';
      }
      h += '</div>';

    } else if (frage.qtype === 'scale') {
      // Jede Stufe traegt ihre eigene Beschriftung. Eine Skala mit nur zwei
      // beschrifteten Enden macht die Mitte zum Sammelbecken.
      h += '<div class="bsv-scale">';
      for (var n = frage.scale_min; n <= frage.scale_max; n++) {
        var anN = a.num === n;
        h += '<label class="bsv-opt' + (anN ? ' is-on' : '') + '">'
           + '<input type="radio" name="' + esc(q) + '" value="' + n + '"' + (anN ? ' checked' : '') + '>'
           + '<span>' + esc(L(frage, 's_' + q + '_' + n, String(n))) + '</span></label>';
      }
      // "weiss nicht" steht abgesetzt neben der Skala und nicht als
      // erzwungene Mitte. Wer die Mitte dafuer missbraucht, macht aus einer
      // Enthaltung eine Meinung.
      for (var k = 0; k < frage.options.length; k++) {
        var ok = frage.options[k];
        var anK = a.options.indexOf(ok) > -1;
        h += '<label class="bsv-opt' + (anK ? ' is-on' : '') + '">'
           + '<input type="radio" name="' + esc(q) + '" value="opt:' + esc(ok) + '"' + (anK ? ' checked' : '') + '>'
           + '<span>' + esc(L(frage, 'o_' + q + '_' + ok, ok)) + '</span></label>';
      }
      h += '</div>';

    } else if (frage.qtype === 'text') {
      h += '<textarea class="bsv-text" rows="4" data-text></textarea>';
    }

    // Freitextfeld an genau der Option, die ihn vorsieht.
    if (frage.text_if) {
      var zeig = a.options.indexOf(frage.text_if) > -1;
      h += '<textarea class="bsv-text" rows="2" data-textif placeholder="'
         + esc(T('other_text', 'Tell us more')) + '"' + (zeig ? '' : ' hidden') + '></textarea>';
    }

    h += '</div>';
    return h;
  }

  function zeichne() {
    var h = '';
    for (var i = 0; i < ZUSTAND.fragen.length; i++) h += baueFrage(ZUSTAND.fragen[i]);
    elFragen.innerHTML = h;

    // Werte der Textfelder nach dem Zeichnen setzen, nicht ins Markup: sonst
    // muesste jeder Freitext durch die HTML-Maskierung und wieder zurueck.
    for (var j = 0; j < ZUSTAND.fragen.length; j++) {
      var f = ZUSTAND.fragen[j];
      var a = ZUSTAND.antworten[f.qkey];
      if (!a || !a.text) continue;
      var box = elFragen.querySelector('[data-q="' + f.qkey + '"] textarea');
      if (box) box.value = a.text;
    }

    // Erledigt-Vermerk fuer alles, was beim Laden schon beantwortet war.
    // Wer den Fragebogen ein zweites Mal oeffnet, sieht sofort, wo er stand.
    for (var k = 0; k < ZUSTAND.fragen.length; k++) {
      var qk = ZUSTAND.fragen[k].qkey;
      var el = elFragen.querySelector('[data-q="' + qk + '"]');
      if (el) el.classList.toggle('is-done', istBeantwortet(qk));
    }

    zebra();
    fortschritt();
  }

  function sichtbarkeitPruefen() {
    for (var i = 0; i < ZUSTAND.fragen.length; i++) {
      var f = ZUSTAND.fragen[i];
      var el = elFragen.querySelector('[data-q="' + f.qkey + '"]');
      if (el) el.hidden = !sichtbar(f);
    }
    zebra();
    fortschritt();
  }

  /* ── Fortschritt ─────────────────────────────────────────────────── */

  function istBeantwortet(qkey) {
    var a = ZUSTAND.antworten[qkey];
    if (!a) return false;
    return (a.options && a.options.length > 0)
        || (a.num !== null && a.num !== undefined)
        || (a.text !== null && a.text !== undefined && String(a.text).trim() !== '');
  }

  /**
   * Raeumt die Kartenflaeche ab, die es hier bis zum 2026-09-02 gab.
   *
   * Frueher verteilte diese Funktion is-band im Wechsel: jede zweite
   * sichtbare Frage bekam eine eigene Flaeche mit Rahmen, jede andere nur
   * eine Haarlinie. Das ist die Bandregel des Hauses, und fuer die
   * Abschnitte einer Seite stimmt sie.
   *
   * Fuer die Fragen einer Abstimmung stimmt sie nicht. Zwei Fragen sind dort
   * GLEICHRANGIG, und ein Wechsel der Flaeche liest sich als Rangunterschied:
   * die eine sieht wichtiger aus als die andere. Beim ersten echten Bogen
   * hat der Betreiber genau das gesehen und gefragt, warum die zweite Frage
   * anders aussieht. Getrennt wird jetzt durch Luft und eine Haarlinie.
   *
   * Die Funktion bleibt stehen, statt ihre beiden Aufrufe zu entfernen: sie
   * muss die Klasse auch dann abraeumen, wenn ein alter Stand sie im Cache
   * noch gesetzt hat oder ein bedingter Zweig sie mitgebracht haette.
   */
  function zebra() {
    var alte = elFragen.querySelectorAll('.bsv-q.is-band');
    for (var i = 0; i < alte.length; i++) alte[i].classList.remove('is-band');
  }

  // Gezaehlt werden nur SICHTBARE Fragen. Ein bedingter Zweig aendert die
  // Gesamtzahl waehrend des Ausfuellens, und ein Balken, der dabei
  // zurueckspringt, ist schlimmer als gar keiner: er sieht aus, als haette
  // man etwas verloren.
  function fortschritt() {
    if (!elProg || !ZUSTAND.fragen.length) return;

    var gesamt = 0, fertig = 0;
    for (var i = 0; i < ZUSTAND.fragen.length; i++) {
      var f = ZUSTAND.fragen[i];
      if (!sichtbar(f)) continue;
      gesamt++;
      if (istBeantwortet(f.qkey)) fertig++;
    }
    if (!gesamt) return;

    var anteil = Math.round((fertig / gesamt) * 100);
    elProgFill.style.width = anteil + '%';
    elProgPct.textContent = anteil + '%';
    elProgBar.setAttribute('aria-valuenow', String(anteil));

    // Der Text nennt die naechste offene Frage, nicht die Zahl der
    // erledigten. "Frage 4 von 9" sagt, wo man steht; "4 erledigt" laesst
    // einen selbst rechnen.
    var offen = Math.min(fertig + 1, gesamt);
    if (fertig >= gesamt) {
      elProgTxt.textContent = T('progress_all', 'All questions answered');
    } else if (gesamt - fertig === 1) {
      elProgTxt.textContent = T('progress_last', 'Last question');
    } else {
      elProgTxt.textContent = T('progress', 'Question {{ current }} of {{ total }}')
        .replace('{{ current }}', offen).replace('{{ total }}', gesamt);
    }

    // Einmaliger Puls beim Vollwerden. Der Merker haengt an einer Variablen
    // und nicht an der Klasse selbst: die Klasse wird nach der Animation
    // wieder entfernt, und ein Abgleich gegen sie wuerde den Puls bei jedem
    // weiteren Aufruf erneut ausloesen.
    var voll = fertig >= gesamt;
    if (voll && !ZUSTAND.warVoll) {
      ZUSTAND.warVoll = true;
      elProg.classList.add('is-full');
      setTimeout(function () { elProg.classList.remove('is-full'); }, 950);
    } else if (!voll) {
      ZUSTAND.warVoll = false;
      elProg.classList.remove('is-full');
    }

    elProg.hidden = false;
  }

  /* ── Antwort aufnehmen und speichern ──────────────────────────────── */

  function ausLesen(qkey) {
    var f = null;
    for (var i = 0; i < ZUSTAND.fragen.length; i++) if (ZUSTAND.fragen[i].qkey === qkey) f = ZUSTAND.fragen[i];
    if (!f) return null;

    var box = elFragen.querySelector('[data-q="' + qkey + '"]');
    if (!box) return null;

    var wert = { options: [], num: null, text: null };

    if (f.qtype === 'text') {
      var ta = box.querySelector('[data-text]');
      wert.text = ta ? ta.value : '';
      return wert;
    }

    var an = box.querySelectorAll('input:checked');
    for (var k = 0; k < an.length; k++) {
      var v = an[k].value;
      if (f.qtype === 'scale') {
        if (v.indexOf('opt:') === 0) wert.options.push(v.slice(4));
        else wert.num = parseInt(v, 10);
      } else {
        wert.options.push(v);
      }
    }

    var tif = box.querySelector('[data-textif]');
    if (tif) {
      var zeig = f.text_if && wert.options.indexOf(f.text_if) > -1;
      tif.hidden = !zeig;
      if (zeig) wert.text = tif.value;
    }

    return wert;
  }

  var speicherLauf = null;

  function speichere(qkey) {
    var wert = ausLesen(qkey);
    if (!wert) return;
    ZUSTAND.antworten[qkey] = wert;
    sichtbarkeitPruefen();

    // Ein einziger offener Speicheraufruf. Schnelles Klicken durch eine
    // Optionsliste erzeugt sonst einen Schwarm Anfragen, und die geteilte
    // Datenbank hat dreissig gleichzeitige Verbindungen.
    if (speicherLauf) clearTimeout(speicherLauf);
    speicherLauf = setTimeout(function () {
      var nutzlast = {};
      var w = { options: wert.options, num: wert.num };
      // Eigenes Feld fuer den kodierten Text. Bis zum 2026-08-22 hiess es
      // 'text', und der Server musste raten, ob der Inhalt kodiert sei. Die
      // Heuristik zerstoerte dabei gewoehnliche Woerter; am Live-PHP
      // gemessen traf es unter anderem "Question".
      if (wert.text != null && wert.text !== '') w.text_b64 = b64(wert.text);
      if (ZUSTAND.fragen.filter(function (x) { return x.qkey === qkey; })[0].qtype === 'single') {
        w.option = wert.options[0] || '';
        delete w.options;
      }
      nutzlast[qkey] = w;

      senden({ action: 'answer', answers: JSON.stringify(nutzlast) }).then(function (res) {
        if (res.ok && res.j && res.j.result === 'ok') melde(T('saved_note', 'Saved'), 'ok');
      }).catch(function () { /* stiller Fehlschlag, der Absendeknopf faengt es */ });
    }, 400);
  }

  /**
   * Springt zur naechsten unbeantworteten Frage.
   *
   * Nur nach einer Einfachauswahl, denn bei Mehrfachauswahl waere man nach
   * dem ersten Haken weg. Nicht, wenn dadurch ein Freitextfeld aufgegangen
   * ist: wer gerade "Sonstiges" gewaehlt hat, will es ausfuellen und nicht
   * verschoben werden.
   *
   * Die kurze Verzoegerung ist Absicht. Ohne sie springt die Seite noch
   * waehrend des Klicks weg, was sich nach einem Fehlgriff anfuehlt, und sie
   * verleitet zum Durchklicken ohne Lesen.
   */
  function weiterZu(qkey) {
    var ab = false;
    for (var i = 0; i < ZUSTAND.fragen.length; i++) {
      var f = ZUSTAND.fragen[i];
      if (f.qkey === qkey) { ab = true; continue; }
      if (!ab || !sichtbar(f) || istBeantwortet(f.qkey)) continue;
      var el = elFragen.querySelector('[data-q="' + f.qkey + '"]');
      if (!el || el.hidden) continue;
      el.scrollIntoView({ behavior: RUHIG ? 'auto' : 'smooth', block: 'center' });
      return;
    }
  }

  elFragen.addEventListener('change', function (e) {
    var box = e.target.closest ? e.target.closest('[data-q]') : null;
    if (!box) return;
    var qkey = box.getAttribute('data-q');

    // Ausgewaehlte Option optisch hervorheben.
    var opts = box.querySelectorAll('.bsv-opt');
    for (var i = 0; i < opts.length; i++) {
      var inp = opts[i].querySelector('input');
      if (inp) opts[i].classList.toggle('is-on', inp.checked);
    }

    // Einmaliger Schimmer auf der gerade gewaehlten Zeile. Er wird vorher
    // ueberall entfernt, sonst bliebe die Klasse liegen und die Animation
    // liefe beim naechsten Neuzeichnen erneut auf allen gewaehlten Zeilen.
    if (!RUHIG) {
      var alle = elFragen.querySelectorAll('.bsv-opt.is-flash');
      for (var j = 0; j < alle.length; j++) alle[j].classList.remove('is-flash');
      var zeile = e.target.closest('.bsv-opt');
      if (zeile && e.target.checked) {
        void zeile.offsetWidth;          // Neustart der Animation erzwingen
        zeile.classList.add('is-flash');
        setTimeout(function () { zeile.classList.remove('is-flash'); }, 560);
      }
    }

    // Mehrfachauswahl ueber ihrer Grenze: die aelteste Wahl faellt weg,
    // statt die neue stumm abzulehnen. Eine Sperre ohne Erklaerung fuehlt
    // sich wie ein Fehler an.
    var f = ZUSTAND.fragen.filter(function (x) { return x.qkey === qkey; })[0];
    if (f && f.qtype === 'multi' && f.max_select) {
      var an = box.querySelectorAll('input:checked');
      if (an.length > f.max_select) {
        an[0].checked = false;
        an[0].closest('.bsv-opt').classList.remove('is-on');
      }
    }

    speichere(qkey);

    // Erledigt-Vermerk an der Frage.
    box.classList.toggle('is-done', istBeantwortet(qkey));
    box.classList.remove('is-missing');

    // Weiterspringen nur bei Einfachauswahl und nur, wenn kein Freitextfeld
    // aufgegangen ist.
    if (f && f.qtype === 'single') {
      var tif = box.querySelector('[data-textif]');
      if (!tif || tif.hidden) setTimeout(function () { weiterZu(qkey); }, 340);
    }
  });

  elFragen.addEventListener('input', function (e) {
    if (e.target.tagName !== 'TEXTAREA') return;
    var box = e.target.closest('[data-q]');
    if (!box) return;
    var qkey = box.getAttribute('data-q');
    speichere(qkey);
    // Kein Weiterspringen beim Tippen. Wer schreibt, ist noch nicht fertig.
    box.classList.toggle('is-done', istBeantwortet(qkey));
  });

  /* ── Laden und Absenden ───────────────────────────────────────────── */

  /* Zeigt die Tafel fuer jemanden, der da ist, aber nicht teilnehmen darf.

     Der Text kommt vom Server: er nennt Zahlen, die nur der Server kennt,
     und unterscheidet fuenf Gruende. Der Rueckfall bleibt englisch und
     allgemein, damit die Tafel auch dann etwas sagt, wenn der Server nur
     einen Schluessel schickt. */
  function zeigeTafel(j) {
    var kasten = wurzel.querySelector('[data-bsv-gate]');
    if (!kasten) {
      // Aelteres Markup: dann wenigstens im vorhandenen Hinweis.
      elNoTok.hidden = false;
      elNoTok.querySelector('.bsv-lead').textContent =
        (j && j.message_en) || T('err_generic', 'You cannot take part in this survey.');
      return;
    }
    var istAnmeldung = j && j.information === 'login_required';

    // Der Titel der Umfrage schlaegt die allgemeine Ueberschrift. Wer aus
    // einem Blogpost kommt, soll zuerst lesen, worum es geht, und erst
    // danach, warum er noch nicht mitmachen kann.
    kasten.querySelector('[data-bsv-gate-title]').textContent =
      (j && j.title_en) ? j.title_en
        : (istAnmeldung ? T('gate_login_title', 'Please sign in')
                        : T('gate_denied_title', 'Not available for your account'));

    var lead = kasten.querySelector('[data-bsv-gate-body]');
    lead.textContent = (j && j.intro_en) ? j.intro_en
      : ((j && j.message_en) || T('err_generic', 'You cannot take part in this survey.'));

    // Steht die Einleitung oben, braucht der Grund eine eigene Zeile. Sonst
    // verschwindet die Auskunft, warum es gerade nicht geht.
    var grund = kasten.querySelector('[data-bsv-gate-reason]');
    if (grund) {
      var hatEigenenTitel = !!(j && j.intro_en);
      grund.textContent = hatEigenenTitel ? ((j && j.message_en) || '') : '';
      grund.hidden = !hatEigenenTitel || !grund.textContent;
    }

    var link = kasten.querySelector('[data-bsv-gate-link]');
    if (link) {
      if (j && j.login_url) {
        link.setAttribute('href', j.login_url);
        link.textContent = T('gate_login_cta', 'Sign in');
        link.hidden = false;
      } else {
        link.hidden = true;
      }
    }

    /* DIE VORSCHAU.

       Gezeichnet wird mit demselben baueFrage(), das auch den echten Bogen
       baut. Ein zweiter Renderer waere beim ersten neuen Fragetyp
       auseinandergelaufen; hier genuegt ein Zustand.

       Bedingte Fragen sind nicht dabei, weil noch nichts beantwortet ist.
       Das ist richtig: der Besucher sieht, was er zuerst saehe. Eine
       Vorschau mit allen Zweigen gleichzeitig verspricht eine laengere
       Umfrage als es ist. */
    if (j && j.questions && j.questions.length) {
      ZUSTAND.fragen    = j.questions;
      ZUSTAND.antworten = {};
      zeichne();
      elFragen.classList.add('is-preview');

      /* Eine Zeile, die sagt, warum sich nichts anklicken laesst. Ohne sie
         sieht die Vorschau wie ein kaputtes Formular aus.

         SIE MUSS DEN GRUND TREFFEN (2026-09-02). Bis dahin stand hier immer
         "Sign in to take part", auch wenn der Besucher laengst angemeldet
         war und nur die Zugangsregel nicht erfuellte. Der Betreiber ist
         genau darauf gestossen: eingeloggt, Haekchen tot, und ein Satz, der
         ihm raet, das zu tun, was er schon getan hatte. Ein falscher Rat ist
         schlimmer als gar keiner, denn er schickt die Suche in die Irre.

         Der genaue Grund steht ohnehin darueber, er kommt vom Server und
         nennt Zahlen. Diese Zeile erklaert nur die abgeschalteten Felder. */
      var hinweis = document.createElement('p');
      hinweis.className = 'bsv-meta';
      hinweis.textContent = istAnmeldung
        ? T('gate_preview_note', 'This is what the survey asks. Sign in to take part.')
        : T('gate_preview_denied', 'This is what the survey asks. Your account cannot take part, see above.');
      elFragen.insertBefore(hinweis, elFragen.firstChild);
      // Jedes Eingabefeld hart abschalten. Die CSS-Klasse allein waere
      // Kosmetik: mit der Tastatur kaeme man weiterhin hinein.
      var felder = elFragen.querySelectorAll('input, textarea, select');
      for (var i = 0; i < felder.length; i++) {
        felder[i].disabled = true;
        felder[i].setAttribute('tabindex', '-1');
      }
      elFragen.setAttribute('aria-disabled', 'true');
      kasten.appendChild(elFragen);
    }

    kasten.hidden = false;
  }

  /* ── Ergebnistafel ──────────────────────────────────────────────────────
     Was die anderen gestimmt haben, NACHDEM man selbst gestimmt hat.

     Die Reihenfolge ist der ganze Sinn: wer vorher sieht, dass zwei Drittel
     fuer eine Antwort sind, beantwortet keine Frage mehr, sondern schliesst
     sich an. Deshalb haengt das hier am abgeschlossenen Bogen und nicht an
     der Seite, und der Server prueft dasselbe noch einmal.

     Der Server schickt nur Zahlen, keine Beschriftungen. Die Frage- und
     Optionstexte liegen bereits aus 'state' vor, und sie hier ein zweites
     Mal zu uebertragen hiesse, zwei Quellen fuer denselben Text zu haben.  */

  function frageZu(qkey) {
    for (var i = 0; i < ZUSTAND.fragen.length; i++) {
      if (ZUSTAND.fragen[i].qkey === qkey) return ZUSTAND.fragen[i];
    }
    return null;
  }

  function balken(text, bp, n) {
    // Prozent auf den ganzen Wert. Eine Nachkommastelle suggeriert eine
    // Genauigkeit, die bei zwanzig Stimmen niemand hat.
    var pct = Math.round(bp / 100);
    return '<div class="bsv-res-row">'
      + '<div class="bsv-res-label"><span>' + esc(text) + '</span>'
      + '<span class="bsv-res-pct">' + pct + '%&nbsp;&middot;&nbsp;' + n + '</span></div>'
      + '<div class="bsv-res-bar"><div class="bsv-res-fill" style="width:' + pct + '%"></div></div>'
      + '</div>';
  }

  function zeigeErgebnis(j) {
    if (!elRes) return;

    var kopf = '<div class="bsv-res-head"><h3>'
      + esc(T('results_title', 'How everyone voted')) + '</h3>';

    if (!j.genug) {
      // Unterhalb der Schwelle rechnet der Server gar nicht erst. Hier steht
      // deshalb auch keine Zahl, die man zurueckrechnen koennte.
      elRes.innerHTML = kopf + '</div><p class="bsv-res-wait">'
        + esc(T('results_wait', 'Results appear once enough people have voted.'))
        + '</p>';
      elRes.hidden = false;
      return;
    }

    kopf += '<p class="bsv-res-note">'
      + esc(T('results_n', '{{ count }} answers so far').replace('{{ count }}', j.antworten))
      + '</p></div>';

    var teile = [];
    var fragen = j.fragen || [];
    for (var i = 0; i < fragen.length; i++) {
      var e = fragen[i];
      var f = frageZu(e.qkey);
      if (!f) continue;

      var block = '<div class="bsv-res-q"><h4>'
        + esc(T('q_' + e.qkey, f.text_en || e.qkey)) + '</h4>';

      // Bei Mehrfachauswahl teilt der Server seit dem 2026-09-03 durch die
      // Zahl der abgegebenen Stimmen, nicht mehr durch die der Personen. Die
      // Frage summiert sich damit auf hundert, aber die einzelne Zahl wird
      // kleiner und braucht ihren Bezug: 16,9 Prozent ohne Nenner liest sich
      // als schwache Zustimmung, obwohl fast jeder Zweite die Option nahm.
      if (e.qtype === 'multi') {
        block += '<p class="bsv-res-hint">'
          + esc(T('results_multi',
                  'People could pick more than one answer here. '
                  + 'The shares are of all votes cast.'))
          + '</p>';
      }

      if (e.qtype === 'scale' && e.skala) {
        for (var s = 0; s < e.skala.length; s++) {
          var st = e.skala[s];
          block += balken(L(f, 's_' + e.qkey + '_' + st.wert, String(st.wert)),
                          st.share_bp, st.n);
        }
      }

      var opt = e.optionen || [];
      for (var o = 0; o < opt.length; o++) {
        block += balken(L(f, 'o_' + e.qkey + '_' + opt[o].key, opt[o].key),
                        opt[o].share_bp, opt[o].n);
      }

      teile.push(block + '</div>');
    }

    // Kein einziger auswertbarer Block heisst: nichts anzeigen. Eine
    // Ueberschrift ohne Inhalt sieht aus wie ein Fehler.
    if (!teile.length) { elRes.hidden = true; return; }

    elRes.innerHTML = kopf + teile.join('');
    elRes.hidden = false;
  }

  function holeErgebnis() {
    if (!elRes) return;
    senden({ action: 'results' }).then(function (res) {
      if (res.ok && res.j && res.j.result === 'ok') zeigeErgebnis(res.j);
    }).catch(function () {
      // Stillschweigend. Das Ergebnis ist eine Zugabe; ein Fehler hier darf
      // die Bestaetigung nicht in eine Fehlermeldung verwandeln.
    });
  }

  function laden() {
    senden({ action: 'state' }).then(function (res) {
      if (!res.ok || !res.j || res.j.result !== 'ok') {
        var k = res.j && res.j.information;

        // Der Proxyweg weist mit HTTP 200 ab, damit eine Ablehnung von einem
        // Signaturfehler unterscheidbar bleibt. Diese Faelle bekommen eine
        // eigene Tafel statt des Hinweises auf den Mail-Link.
        if (k === 'login_required' || k === 'not_eligible') { zeigeTafel(res.j); return; }

        elNoTok.hidden = false;
        elNoTok.querySelector('.bsv-lead').textContent =
            k === 'expired'  ? T('err_expired', 'This link has expired.')
          : k === 'closed'   ? T('err_closed', 'This survey has closed.')
          : k === 'not_open' ? T('err_closed', 'This survey has closed.')
                             : T('err_token', 'This link is not valid.');
        return;
      }

      ZUSTAND.fragen    = res.j.questions || [];
      ZUSTAND.antworten = res.j.answers || {};

      /* Titel und Einleitung.

         Fuer exit_v1 und join_v1 liefert der Server sie leer, und es bleibt
         beim Locale-Text wie bisher. Ein im Admin angelegter Bogen hat in
         den Sprachdateien keinen Eintrag und koennte gar keinen bekommen,
         ohne dass jemand das Theme pusht; er bringt seinen englischen Satz
         deshalb selbst mit. */
      if (res.j.intro_en) {
        elLead.textContent = res.j.intro_en;
      } else {
        elLead.textContent = (res.j.kind === 'exit')
          ? T('lead_exit', '') : T('lead_join', '');
      }
      var elTitel = wurzel.querySelector('[data-bsv-title]');
      if (elTitel && res.j.title_en) elTitel.textContent = res.j.title_en;

      zeichne();
      elMain.hidden = false;

      if (res.j.status === 'complete') {
        elMain.hidden = true;
        elDone.hidden = false;
        if (elProg) elProg.hidden = true;
        // Der Weg des Wiederkehrers. Er sieht das Formular nie und bekaeme
        // ohne diese Zeile als Einziger kein Ergebnis zu sehen, obwohl genau
        // er zurueckkommt, um nachzusehen wie es ausgegangen ist.
        if (res.j.show_results) holeErgebnis();
      }
    }).catch(function () {
      elNoTok.hidden = false;
      elNoTok.querySelector('.bsv-lead').textContent = T('err_network', 'We could not reach the server.');
    });
  }

  elForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (speicherLauf) { clearTimeout(speicherLauf); speicherLauf = null; }

    elSubmit.disabled = true;
    melde(T('submitting', 'Sending'), 'ok');

    // Vor dem Abschluss alles noch einmal geschlossen senden. Der laufende
    // Zwischenspeicher kann einen letzten Tastendruck verpasst haben.
    var alle = {};
    for (var i = 0; i < ZUSTAND.fragen.length; i++) {
      var f = ZUSTAND.fragen[i];
      if (!sichtbar(f)) continue;
      var w = ausLesen(f.qkey);
      if (!w) continue;
      var p = { options: w.options, num: w.num };
      if (w.text != null && w.text !== '') p.text_b64 = b64(w.text);
      if (f.qtype === 'single') { p.option = w.options[0] || ''; delete p.options; }
      alle[f.qkey] = p;
    }

    senden({ action: 'answer', answers: JSON.stringify(alle) })
      .then(function () { return senden({ action: 'complete' }); })
      .then(function (res) {
        elSubmit.disabled = false;

        if (res.ok && res.j && res.j.result === 'ok') {
          melde('', null);
          elMain.hidden = true;
          elDone.hidden = false;
          if (elProg) elProg.hidden = true;
          if (res.j.show_results) holeErgebnis();
          window.scrollTo({ top: wurzel.offsetTop - 80, behavior: 'smooth' });
          return;
        }

        var k = res.j && res.j.information;
        if (k === 'missing_required') {
          var fehlt = (res.j.missing || []);
          var alt = elFragen.querySelectorAll('.bsv-q.is-missing');
          for (var m = 0; m < alt.length; m++) alt[m].classList.remove('is-missing');
          for (var n = 0; n < fehlt.length; n++) {
            var el = elFragen.querySelector('[data-q="' + fehlt[n] + '"]');
            if (el) el.classList.add('is-missing');
          }
          melde(T('err_missing', 'Please answer the marked questions first.'), 'err');
          var erste = elFragen.querySelector('.bsv-q.is-missing');
          if (erste) erste.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (k === 'window_closed') { melde(T('err_closed', ''), 'err'); return; }
        melde(T('err_generic', 'Something went wrong.'), 'err');
      })
      .catch(function () {
        elSubmit.disabled = false;
        melde(T('err_network', 'We could not reach the server.'), 'err');
      });
  });

  var reopen = wurzel.querySelector('[data-bsv-reopen]');
  if (reopen) reopen.addEventListener('click', function () {
    elDone.hidden = true;
    elMain.hidden = false;
    fortschritt();
  });

  laden();
})();
